import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getBuyerInvoices = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/`, body);
        return response.data.data;
    } catch (error) {
        console.log("getBuyerInvoices - error", error)
        return handleApiError(error)
    }
}

export const getBuyerInvoiceById = async (buyerInvoiceId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-invoice/${buyerInvoiceId}`);
        return await response.data;
    } catch (error) {
        console.log("getbuyerInvoiceById - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBuyerInvoice - error", error)
        return handleApiError(error)
    }
}

export const createInternalTransferInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/insert/internal-transfer`, data);
        return await response.data;
    } catch (error) {
        console.log("createInternalTransferInvoice - error", error)
        return handleApiError(error)
    }
}

export const createFinancialInternalTransferInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/insert/financial-internal-transfer`, data);
        return await response.data;
    } catch (error) {
        console.log("createFinancialInternalTransferInvoice - error", error)
        return handleApiError(error)
    }
}

export const downloadBuyerInvoice = async (docNo, pdfType) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-invoice/download/${docNo}?pdfType=${pdfType}`);
        return await response.data;
    } catch (error) {
        console.log("downloadBuyerInvoice - error", error)
        return handleApiError(error)
    }
}

export const assignDocNoToBuyerInvoice = async (buyerInvoiceId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/assign-docno/${buyerInvoiceId}`);
        return await response.data;
    } catch (error) {
        console.log("assignDocNoToBuyerInvoice - error", error)
        return handleApiError(error)
    }
}

export const generateBuyerEInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/e-invoice`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBuyerInvoice - error", error)
        return handleApiError(error)
    }
}

export const cancelBuyerEInvoice = async (buyerInvoiceId, data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/cancel/${buyerInvoiceId}`, data);
        return await response.data;
    } catch (error) {
        console.log("cancelBuyerEInvoice - error", error)
        return handleApiError(error)
    }
}

export const getBuyerInvoicesByBuyerPOIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/buyerPOIds`, data);
        return response.data;
    } catch (error) {
        console.log("getBuyerInvoices - error", error)
        return handleApiError(error)
    }
}

export const getBuyerInvoicesByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/buyerReqIds`, data);
        return response.data;
    } catch (error) {
        console.log("getBuyerInvoicesByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const generateEwayBill = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-invoice/e-way-bill`, data);
        return await response.data;
    } catch (error) {
        console.log("generateEwayBill - error", error)
        return handleApiError(error)
    }
}

export const getEWayBillById = async (ewayBillId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-invoice/e-way-bill/${ewayBillId}`);
        return await response.data;
    } catch (error) {
        console.log("getEWayBillById - error", error)
        return handleApiError(error)
    }
}

export const getEWayBillDocument= async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-invoice/ewaybill/document/`);
        return await response.data;
    } catch (error) {
        console.log("getEWayBillDocument - error", error)
        return handleApiError(error)
    }
}

export const getBuyerInvoiceByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-invoice/get-buyer-invoice-by-doc-no/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerInvoiceByDocNo - error", error)
        return handleApiError(error)
    }
}
